var globalNotificationTokenArray = [];
export {globalNotificationTokenArray}